import { View } from "@-/com.npmjs.react-native";
import { Skeleton } from "@-/dev.improve.haniverse.components.ui.skeleton";
import { BoundedSuspense } from "@-/dev.improve.haniverse.components.ui.suspense-page";
import { useDeferredValue, type ReactNode } from "react";

/** Mounted only while open, so each expansion commits its shell before rendering the body. */
export function SectionAccordionContent({
  children,
  fallback: fallbackContent,
  title,
}: {
  children?: ReactNode;
  /** Placeholder mirroring the body's layout; defaults to generic text lines. */
  fallback?: ReactNode;
  title: string;
}) {
  const renderContent = useDeferredValue(true, false);
  const fallback = (
    <View accessibilityLabel={`Loading ${title} content`} accessibilityState={{ busy: true }}>
      {fallbackContent ?? (
        <View className="gap-3 p-4">
          <Skeleton className="h-5 w-3/4" />
          <Skeleton className="h-5 w-full" />
          <Skeleton className="h-5 w-1/2" />
        </View>
      )}
    </View>
  );

  // Deferring the first mount lets the header and skeleton commit without waiting for costly
  // children. A local boundary also keeps async children from suspending the entire tab. Bounded,
  // so a body that never finishes loading ends on the page's error screen, not a skeleton forever.
  return (
    <BoundedSuspense fallback={fallback} operation={`section accordion content "${title}"`}>
      {renderContent ? children : fallback}
    </BoundedSuspense>
  );
}
